
const apiKey = process.env.REACT_APP_MICROCMS_API_KEY
const BASE_URL = process.env.REACT_APP_MICROCMS_BASE_URL
interface FetchOptions {
    method?: string;
    headers?: Record<string, string>;
    body?: string;
}

export const fetchDataFromMicroCMS = async <T>(
    endpoint: string, 
    method: string = 'GET',
    body: any = null
): Promise<T> => { 
    try {
        const url = `${BASE_URL}${endpoint}`;
        const options: FetchOptions = {
            method,
            headers: {
                'Content-Type': 'application/json',
                ...(apiKey && { 'X-API-KEY': apiKey }),
            },
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }
        return await response.json() as T;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};
